<script setup lang="ts">
import type { Ref } from 'vue'
import { ref } from 'vue'
import PageXPIndex from './PageXPIndex.vue'

const emit = defineEmits(['close'])

const theXPTag: Ref<string | null> = ref(null)

function setXPTag(editingtheXPTag: string) {
  theXPTag.value = editingtheXPTag
}
</script>

<template>
  <div>
    <PageXPIndex @close="emit('close')" @select="setXPTag" />
  </div>
</template>
